export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000/api';

export const TOKEN_STORAGE_KEY = 'hitachi_token';
export const USER_STORAGE_KEY = 'hitachi_user';
export const STORE_STORAGE_KEY = 'hitachi_selected_store';

